/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

import { ROOT_CONTEXT } from './context';
import type * as types from './types';

export class NoopContextManager implements types.ContextManager {
  active(): types.Context {
    return ROOT_CONTEXT;
  }

  with<A extends unknown[], F extends (...args: A) => ReturnType<F>>(
    _context: types.Context,
    fn: F,
    thisArg?: ThisParameterType<F>,
    ...args: A
  ): ReturnType<F> {
    return fn.call(thisArg, ...args);
  }

  bind<T>(_context: types.Context, target: T): T {
    return target;
  }

  enable(): this {
    return this;
  }

  disable(): this {
    return this;
  }

  /** @experimental This API is experimental and may change in minor releases without prior notice. */
  attach(_context: types.Context): types.ContextManagementToken {
    return { dispose() {} };
  }
}
